<form [formGroup]="formGroup">
    <p>Termos de aceite:</p>

    <ng-container *ngIf="isLoading">
        <div class="field">
            <div class="loading-placeholder-container">
                <app-loading-placeholder></app-loading-placeholder>
            </div>
        </div>
        <div class="field">
            <div class="loading-placeholder-container">
                <app-loading-placeholder></app-loading-placeholder>
            </div>
        </div>
        <div class="field">
            <div class="loading-placeholder-container">
                <app-loading-placeholder></app-loading-placeholder>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!isLoading">
        <div class="html-content" *ngIf="termsContent" 
            [innerHTML]="termsContent">
        </div>
        <app-checkbox-input
            [formControlName]="'termo'"
            [mandatory]="mandatory"
            [name]="'Estou ciente e desejo continuar'"
            (change)="handleInput($event)"
        >
        </app-checkbox-input>
    </ng-container>
</form>
